/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S18_I5_TextInputs */

const tr_kullanim_s18_i5_text = /** @type {(inputs: Kullanim_S18_I5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı'nın kayıtlı e-posta adresi ve bildirmesi halinde KEP adresi geçerli tebligat adresidir.`)
};

const en_kullanim_s18_i5_text = /** @type {(inputs: Kullanim_S18_I5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The User's registered email address and, if the User notifies one, the KEP address are the valid address for service.`)
};

const de_kullanim_s18_i5_text = /** @type {(inputs: Kullanim_S18_I5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die registrierte E-Mail-Adresse des Nutzers und, sofern er sie mitteilt, die KEP-Adresse sind die wirksame Zustellungsadresse.`)
};

const ru_kullanim_s18_i5_text = /** @type {(inputs: Kullanim_S18_I5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрированный адрес электронной почты Пользователя и, если он его сообщит, адрес KEP являются действительным адресом для уведомлений.`)
};

/**
* | output |
* | --- |
* | "The User's registered email address and, if the User notifies one, the KEP address are the valid address for service." |
*
* @param {Kullanim_S18_I5_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s18_i5_text = /** @type {((inputs?: Kullanim_S18_I5_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S18_I5_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s18_i5_text(inputs)
	if (locale === "de") return de_kullanim_s18_i5_text(inputs)
	if (locale === "ru") return ru_kullanim_s18_i5_text(inputs)
	return tr_kullanim_s18_i5_text(inputs)
});